import React, {useContext} from "react"
import Row from "@amzn/meridian/row";
import Heading from "@amzn/meridian/heading";
import Text from "@amzn/meridian/text";
import {FormattedMessage} from "react-intl";
import {convertSecondsToTimeFormat, getTimeInSecond} from "../util/Util";
import Table, {TableCell, TableRow} from "@amzn/meridian/table";
import Tag from "@amzn/meridian/tag";
import Link from "@amzn/meridian/link";
import {CapabilityContext} from "../global/context/CapabilityContext";
import {RouteStageContext} from "../stageStatus/context/RouteStageContext";
import {getStageStatusColor} from "../util/EntityStatusManager";

const AssociateDetail = (props) => {

    const {viewModel} = useContext(RouteStageContext)
    const {configViewModel} = useContext(CapabilityContext)


    const getAssociateRoutes = () => {
        const associateRoutes = [];
        viewModel.routeList.forEach(route => {
            if (route.picker === props.associate) {
                associateRoutes.push({
                    routeCode: route.routeCode,
                    status: route.stageStatus,
                    progress: route.stageProgress,
                    duration: route.stageDuration,
                    statusTag: getStageStatusColor(route.stageStatus),
                    startTime: route.startTime,
                    endTime: route.endTime
                })
            }
        });
        return associateRoutes;
    }


    const rowsData = getAssociateRoutes();

    const getAverageStageTime = () => {
        let totalRouteStageTime = 0;
        let count = 0;
        rowsData.forEach(row => {
            if (row.duration !== "...") {
                totalRouteStageTime = totalRouteStageTime + getTimeInSecond(row.duration);
                count++;
            }
        })
        if (count > 0) {
            const averageStageTimeInSecond = totalRouteStageTime / count
            return convertSecondsToTimeFormat(averageStageTimeInSecond)
        }
        return 0;
    }

    const getPhoneToolLink = () => {
        const alias = props.associate;
        return "https://phonetool.amazon.com/users/" + alias;
    }

    const renderAssociateMetadata = () => {
        return <Row backgroundColor={"secondary"} spacingInset="medium" spacing={"xlarge"}>
            <Row>
                <Text type="h100">
                    <FormattedMessage id="associate.averageStageTime" defaultMessage="Average Stage Duration"/>
                </Text>
                <Text type="b200">{getAverageStageTime()} mins</Text>
            </Row>
            <Row>
                <Text type="h100">
                    <FormattedMessage id="routeInfo.associate" defaultMessage="Associate"/>
                </Text>
                <Link href={getPhoneToolLink()} type="secondary" target="_blank" rel="noreferrer noopener">
                    {props.associate}
                </Link>
            </Row>
        </Row>
    }

    const renderAssociateTable = () => {
        return <Table headerRows={1} showDividers={true} showStripes={true} spacing="medium">
            {renderAssociateTableHeader()}
            {renderAssociateRows()}
        </Table>
    }

    const renderAssociateTableHeader = () => {
        return <TableRow>
            <TableCell>
              <FormattedMessage id="associate.route" defaultMessage="Route"/>
            </TableCell>
            <TableCell>
                <FormattedMessage id="associate.status" defaultMessage="Status"/>
            </TableCell>
            <TableCell>
                <FormattedMessage id="associate.progress" defaultMessage="Progress"/>
            </TableCell>
            <TableCell>
                <FormattedMessage id="associate.duration" defaultMessage="Duration"/>
            </TableCell>
            <TableCell>
                <FormattedMessage id="associate.start_time" defaultMessage="Start Time"/>
            </TableCell>
            <TableCell>
                <FormattedMessage id="associate.end_time" defaultMessage="End Time"/>
            </TableCell>
        </TableRow>
    }

    const renderAssociateRows = () => {
        return rowsData.map(row => {
            const primaryKey = configViewModel.stationConfig.parallelPickEnabled ? row.picklistCode : row.routeCode;
            return <TableRow key={primaryKey}>
                <TableCell>{primaryKey}</TableCell>
                <TableCell>
                    <Tag type={row.statusTag}>{row.status}</Tag>
                </TableCell>
                <TableCell>{row.progress}</TableCell>
                <TableCell>{row.duration}</TableCell>
                <TableCell>{row.startTime}</TableCell>
                <TableCell>{row.endTime}</TableCell>
            </TableRow>
        })
    }

    return (
        <div>
            <Row widths="100%" spacingInset="small large small">
                <Heading level={3} type="h600" alignment="left">{props.associate}</Heading>
            </Row>
            <Row widths="100%" spacingInset="small large small">
                {renderAssociateMetadata()}
            </Row>
            <Row widths="100%" spacingInset="small large small">
                {renderAssociateTable()}
            </Row>
        </div>
    );
}

export default AssociateDetail


// WEBPACK FOOTER //
// ./src/components/associate/AssociateDetail.js